export const sessionActivityEvents = ['click', 'scroll', 'touchstart'];
